import { render, staticRenderFns } from "./addChild.vue?vue&type=template&id=5cd3f2ea"
import script from "./addChild.vue?vue&type=script&lang=js"
export * from "./addChild.vue?vue&type=script&lang=js"
import style0 from "./addChild.vue?vue&type=style&index=0&id=5cd3f2ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports